<template>
    <div class="container">
      <h1>統一發票對獎APP</h1>
      <div class="form-group">
        <label for="number">請輸入發票對獎號碼末3碼</label>
        <input type="number" class="form-control" @input="hadle_input_number" v-model="input_number" pattern="\d*">
      </div>
      <h3>{{ all_list[0].range }}</h3>
      <table class="table">
          <tr v-for="(item, key) in all_list[0].number_list" :key="key" v-if="item.show">
              <td width="40%">{{ item.name | getHead }}</td>
              <td>{{ item.number }}</td>
          </tr>
      </table>
      <h3>{{ all_list[1].range }}</h3>
      <table class="table">
          <tr v-for="(item, key) in all_list[1].number_list" :key="key" v-if="item.show">
              <td width="40%">{{ item.name | getHead }}</td>
              <td>{{ item.number }}</td>
          </tr>
      </table>
      <hr>
      <div class="text-center">
        Copyright © 2019 <a href="https://www.pureday.life/">純生活網</a>
      </div>
    </div>
</template>

<script>
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
    data () {
        return {
          all_list:[
              {
                  range:'108年01-02月',
                  number_list:[
                      {
                          name: 'sspec_number',
                          show: true,
                          number: '00106725',
                      },
                      {
                          name: 'spec_number',
                          show: true,
                          number: '90819218',
                      },
                      {
                          name: 'head_number',
                          show: true,
                          number: '13440631',
                      },
                      {
                          name: 'head_number',
                          show: true,
                          number: '26650552',
                      },
                      {
                          name: 'head_number',
                          show: true,
                          number: '09775722',
                      },
                      {
                          name: 'extra_number',
                          show: true,
                          number: '809',
                      },
                      {
                          name: 'extra_number',
                          show: true,
                          number: '264',
                      },
                  ]
              },
              {
                  range:'107年11-12月',
                  number_list:[
                      {
                          name: 'sspec_number',
                          show: true,
                          number: '88515559',
                      },
                      {
                          name: 'spec_number',
                          show: true,
                          number: '47551146',
                      },
                      {
                          name: 'head_number',
                          show: true,
                          number: '83513656',
                      },
                      {
                          name: 'head_number',
                          show: true,
                          number: '85250862',
                      },
                      {
                          name: 'head_number',
                          show: true,
                          number: '61472404',
                      },
                      {
                          name: 'extra_number',
                          show: true,
                          number: '185',
                      },
                      {
                          name: 'extra_number',
                          show: true,
                          number: '079',
                      },
                      {
                          name: 'extra_number',
                          show: true,
                          number: '442'
                      }
                  ]
              }
          ],
          input_number: '',
          sudo:['dd','bb','dd'],
          select_number:[],
          select_grid_id:0,
          select_grid_item:[],
          second:0,
          timer:[],
          time_compute:false
        }
      },
    filters: {
        getHead: function (val) {
          if(val==='sspec_number') return '特別獎'
          else if(val==='spec_number') return '特獎'
          else if(val==='head_number') return '頭獎'
          else if(val==='extra_number') return '增開六獎'
        }
    },
    methods: {
        hadle_input_number: function(){
            if(this.input_number===''){
                this.clean()
                return
            }
            var self = this
            var check = false
            this.all_list[0].number_list.forEach(function(item){
                if(item.number.slice(-3).search(self.input_number)!=-1){
                    item.show = true
                    check = true
                }else{
                    item.show = false
                }
            })
            this.all_list[1].number_list.forEach(function(item){
                if(item.number.slice(-3).search(self.input_number)!=-1){
                    item.show = true
                    check = true
                }else{
                    item.show = false
                }
            })
            
            if(this.input_number.length >=3 && check == false){
                this.clean()
                this.input_number = ''
            }
        },
        clean: function(){
            this.all_list[0].number_list.forEach(function(item){
                item.show = true
            })
            this.all_list[1].number_list.forEach(function(item){
                item.show = true
            })
        }
    }
}
</script>